<template>
    <div class="process">
       <div class="liucheng__title-con">
            <div class="liucheng__title">
                <span class="liucheng__title_item">项目名称：{{model.proName}}</span>
                <span class="liucheng__title_item">项目编码：{{model.zbProCode}}</span>
            </div>
        </div>
        
        <flow-common v-if="redirect=='common'" :model="model" @click="clickHandler"></flow-common>
        <flow-otherFlow v-if="redirect=='other'" :model="model" @click="clickHandler"></flow-otherFlow>
        <el-dialog
            title="选择标段"
            :visible.sync="dialogVisible"
            style="text-align:left"
            width="30%">
            <div>
                <my-checkbox
                    model-str
                    str-spliter=","
                    v-model="bdcodes"
                    :data="model.bdList"
                    :props="{label:'bdname',value:'bdcode'}">
                </my-checkbox>
                
            </div>
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="yycd">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

import './style/flow.scss';
const fileDownload = require('@views/bidding/config/jquery.fileDownload');

export default {
    components: {
        FlowCommon: () => import('./common/index'),
        FlowOtherFlow: () => import('./otherFlow/index'),
    },
    data() {

        return{
            model:{},
            redirect:'common',
            oldProcess:[],
            newProcess:[],
            identicalData:[],//相同数据
            differentData:[],//不同数据
            dialogVisible:false,
            bdcodes:''
        }
    },
    computed: {
        id: function() {
            return this.getQuery('id') || '';
        },
    },
    watch: {
     
    },
    methods: {
        gotoNode({url, query},isnew) {
            if(isnew!=='1') {
                if(window === window.top) {
                    this.goto({
                        path: '/iframe',
                        query: {
                            ...query,
                            url: url
                        }
                    })
                } else {
                    window.location.assign(url);
                }
            } else {
                this.goto(url);
            }
        },
        clickHandler(data){
            var that = this
            if(data.issh=='1'&&that.model.dateRule){
                that.goto({
                    path: '/iframe',
                    query: {
                        url: data.shurl+that.id
                    }
                })
                return;
            }
            // 特殊节点点击
            if(data.isclick=='click'){
                //预约场地
                if(data.nodename=='获取开标室'||data.nodename=='预约场地'){
                    
                    if(that.model.ext4=='130300'){
                        ShowMsg('请联系交易中心获取开标室')
                        return
                    }
                    // if(that.model.jyZxCode=='J13052301'){
                    //     ShowMsg('请联系内丘县公共资源交易中心工作人员预约')
                    //     return
                    // }
                    if(that.model.bdCodes==null||that.model.bdCodes==''){
                        ShowMsg('请先推送标段信息')
                        return
                    }else{
                        if(that.model.bdList.length==1){
                            if(that.model.ng){
                                // 经济开发区 转code
                                if(that.model.regionCode=='130583'){
                                    window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.model.bdCodes+'&region_Code=130571')
                                }else if(that.model.regionCode=='130584'){
                                    window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.model.bdCodes+'&region_Code=130596')
                                }else{
                                    window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.model.bdCodes+'&region_Code='+that.model.regionCode)
                                }
                                
                            }else{
                                window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.model.bdCodes)
                            }
                        }else{
                            that.dialogVisible = true;
                        }
                        
                    }
                }else if(data.nodename=='数据导出'){
                    //数据导出
                    $.get(`${that.getGetters('ageUrl')}/Zbdl/sjtj/exportStatus.json`, {
                        zbprocode:that.id,
                        t:Math.random(),
                    }, data => {
                        if(data.code=='v'){
                            // 遮罩
                            var loading = that.$loading({
                                lock: true,
                                text: '正在导出',
                                spinner: 'el-icon-loading',
                                background: 'rgba(225, 225, 225, 0.7)'
                            });
                            var httpMethod = 'post';
                            var url = '/Zbdl/sjtj/exportExcel.do?zbprocode='+that.id+'&isqz=1'
                            $.fileDownload(url, {
                                httpMethod: httpMethod,
                                // 因为这个插件貌似只支持URL参数,所以要用jquery param将js对象转成URL参数
                                data: '',
                                prepareCallback: function (url) {
                                    console.log("正在导出...");
                                
                                },
                                //要想成功回调失败和成功方法，要在响应首部加 response.setHeader("Set-Cookie", "fileDownload=true; path=/");
                                successCallback: function (url) {
                                    console.log("导出成功");
                                    loading.close()
                                },
                                failCallback: function (html, url) {
                                    console.log("导出失败");
                                    loading.close()
                                }
                            });
                        }else if(data.code=='error'){
                            ShowMsg(data.msg,'warning')
                        }
                        
                    })
                    
                    
                }
                
            }else if(data.isclick=='open_kb'){
                window.open(data.nodeurl+that.id)
            }else{
                
                // 半流程节点跳转
                if(data.isblc=='1'&&that.model.zbGj){
                    that.goto({
                        path: '/iframe',
                        query: {
                            url: data.hisurl+that.id
                        }
                    })
                }else{
                    //正常节点跳转
                    
                    that.gotoNode({
                        url: data.nodeurl + that.id,
                        
                    },data.isnew)
                }
                
            }

        },
        // 邢台预约场地
        yycd(){
            var that = this
            if(that.bdcodes==''){
                ShowMsg('请选择标段')
                return
            }
            if(that.model.ng){
                // 经济开发区 转code
                if(that.model.regionCode=='130583'){
                    window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.bdcodes+'&region_Code=130571')
                }else if(that.model.regionCode=='130584'){
                    window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.bdcodes+'&region_Code=130596')
                }else{
                    window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.bdcodes+'&region_Code='+that.model.regionCode)
                }
            }else{
                window.open(that.model.xtCd+'/sszt-zyjyTrading/zyjy/xtdj/zyjyDsfbulletin/cdyy?syms='+that.bdcodes)
            }
        },
        // 获取旧系统数据
        oldData(){
            var that = this
            var routeUrl = '/Zbdl/ZbProject/newwfdis.do?id='
            if(that.model.processType.indexOf('ZFCG')>-1){
                var routeUrl = '/Zbdl/GovPurchase/newwfdis.do?id='
            }
            $.get(routeUrl+that.id+'&&q=Q',function(data,status,xhr){
                var htmldoc=new DOMParser().parseFromString(data,"text/html");
                var tagNameList = htmldoc.getElementsByTagName("a");
                // 循环旧系统数据 组成数组
                for(var i=0;i<tagNameList.length;i++){
                    if(tagNameList[i].innerText.trim() !== '返回'){
                        var json = {};
                        if(tagNameList[i].href){
                            var  url = tagNameList[i].href.split('?')
                            json.href = url[0];
                        }else{
                            json.href = url;
                        }
                        json.name = tagNameList[i].innerText;
                        that.oldProcess.push(json);
                    }
                    
                }
                // console.log(JSON.stringify(that.oldProcess))
                // 循环新系统数据 组成数组
                for(var i=0;i<that.model.nodeList.length;i++){
                    that.model.nodeList[i].child.forEach(function(item){
                        var obj = {}
                        if(item.nodeurl){
                            var url = item.nodeurl.split('?')
                            obj.url = 'http://'+ window.location.host + url[0]
                        }else{
                            obj.url = 'http://'+ window.location.host + url
                        }
                        obj.name = item.nodename
                            that.newProcess.push(obj)
                    })
                }
                // console.log(JSON.stringify(that.newProcess))
                // 获取新旧数据相同数据
                that.newProcess.forEach(function(data){
                    that.oldProcess.forEach(function(item){
                        if(data.url===item.href){
                            that.identicalData.push(item)
                        }
                    })
                })
               
                // console.log(JSON.stringify(that.identicalData))
                // 旧系统数据判断是否与集合一致
               for(var i =0;i<that.oldProcess.length;i++){
                   var isExist = false;
                   for(var j = 0; j < that.identicalData.length; j++){
                        if(that.identicalData[j].href == that.oldProcess[i].href){
                            isExist = true;
                            break;
                        }
                        if(that.identicalData[j].name == that.oldProcess[i].name){
                            isExist = true;
                            break;
                        }
                    }
                    if(!isExist){ 
                        that.differentData.push(that.oldProcess[i].name)
                    }
               }
 
                // 新系统数据判断是否与集合一致
                for(var i =0;i<that.newProcess.length;i++){
                   var isExist = false;
                   for(var j = 0; j < that.identicalData.length; j++){
                        if(that.identicalData[j].href == that.newProcess[i].url){
                            isExist = true;
                            break;
                        }
                        if(that.identicalData[j].name == that.newProcess[i].name){
                            isExist = true;
                            break;
                        }
                    }
                    if(!isExist){ 
                        that.differentData.push(that.newProcess[i].name)
                    }
               }
                //去重后的提醒信息
                if(that.differentData.length>0){
                    var msg = ''
                    msg = $.unique(that.differentData)
                    // ShowMsg(msg.toString()+'节点有问题')
                }
                
            },'html')
        },

    },
    created() {
        
    },
    mounted() {
        var that = this
        that.$get(`${this.getGetters('mngUrl')}/project/node/process.json`, {
            id:that.id
        }, (data, res) => {
            that.model = data
            if(that.model.processType==='TWO'||that.model.processType==='ZGYS'){
                that.redirect = 'other'
            }else{
                that.redirect = 'common'
            }
            // that.oldData()
        });
    }
}
</script>

<style scoped lang="scss">
   /deep/ .el-checkbox{ display: block; margin-bottom: 10px;}
   /deep/ .el-dialog__body{ max-height: 300px; overflow: auto; }
</style>
